function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#107ff9;}.cls-2{fill:#28e0d2;}.cls-3{fill:#2fb7ed;}.cls-4{fill:#2d2d2d;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M60.72,28.61,44.48,12.36,52.88,4A13.51,13.51,0,0,0,33.77,23.07L59.49,48.79a12.4,12.4,0,0,0,1.23-1.07A13.51,13.51,0,0,0,60.72,28.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M5.18,32.7A13.45,13.45,0,0,0,4,52.88L20.2,69.13l-8.41,8.4A13.51,13.51,0,0,0,30.9,58.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M20.09,17.79a12.4,12.4,0,0,0-1.22,1.08,13.51,13.51,0,0,0,0,19.11L44.59,63.7a13.67,13.67,0,0,0,1.22-1.08,13.51,13.51,0,0,0,0-19.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M193.75,80.27V49.32a25.14,25.14,0,0,1,1.78-9.6,19.72,19.72,0,0,1,5.18-7.35A20.57,20.57,0,0,1,209,28a25,25,0,0,1,6.7-.86,33.33,33.33,0,0,1,4.26.28l.6.07v13l-.81-.15a17.83,17.83,0,0,0-2.9-.26,9.63,9.63,0,0,0-6,1.86,8.6,8.6,0,0,0-3.33,7.34V80.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M95.71,58.46v1c0,5.07,4.39,8.78,10.24,8.78,5.63,0,9.9-3.49,9.9-8a7.44,7.44,0,0,0-3-6c-1.91-1.47-3.26-2-9.11-4.17-16.43-5.85-22.28-12-22.28-23.51,0-13.62,10-22.73,24.75-22.73s24.08,8.55,25.32,23H116c-.56-6.3-3.71-9.34-9.79-9.34-5.51,0-9.22,3.15-9.22,7.88,0,3,1.57,5.4,4.61,7.09,2,1.12,3.26,1.69,8.78,3.71,8.21,3,12.37,5.18,15.64,8.33a19.41,19.41,0,0,1,6,14.51c0,13.73-10.35,22.85-25.88,22.85-15.75,0-25.43-9-25.32-23.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M239.46,57.07c1.24,7.2,6.53,11.71,13.62,11.71a13.36,13.36,0,0,0,12-6.75l12,3.6C271.92,75.75,264,81.49,253,81.49c-16.54,0-26.52-11.7-26.52-27.9s9.52-27.8,25.62-27.8c16.65,0,26.4,11.71,26.4,28.47l-.11,2.81Zm26.11-8.21c-1.24-6.86-6.19-11-13.28-11-6.86,0-11.48,3.94-12.83,11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M300,57.07c1.23,7.2,6.52,11.71,13.61,11.71a13.36,13.36,0,0,0,12-6.75l12,3.6c-5.17,10.12-13.11,15.86-24.13,15.86C297,81.49,287,69.79,287,53.59s9.53-27.8,25.62-27.8C329.26,25.79,339,37.5,339,54.26l-.12,2.81Zm26.1-8.21c-1.24-6.86-6.19-11-13.28-11-6.86,0-11.47,3.94-12.82,11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M178.66,64.68c-3.53,3-6.19,4.1-9.78,4.1-8.33,0-14.29-6.42-14.29-15.31,0-8.55,5.85-15,13.73-15A14.33,14.33,0,0,1,179,43.12l9.56-8.66c-6.64-6-13-8.67-20.81-8.67-16.21,0-27.68,11.71-27.68,28.13,0,15.87,11.7,27.57,27.56,27.57a27.76,27.76,0,0,0,19.3-7.15Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "408.96 28 398.38 59.73 389.29 28.83 375.08 28.83 366.2 59.73 355.74 28 341.22 28 359.51 80.1 373.18 80.1 382.52 48.14 391.63 80.1 404.96 80.1 423.47 28 408.96 28"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 423.47 81.87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f7f448b0.svg";
export { ForwardRef as ReactComponent };